<template>
  <v-navigation-drawer absolute temporary v-model="sidebarState" width="350">
    <div class="pa-2">
      <v-autocomplete
        filled
        rounded
        dense
        hide-details
        prepend-inner-icon="search"
        placeholder="Search Contexts"
        :items="Object.values(allContexts)"
        item-text="text"
        item-value="id"
        @change="$router.push({ name: 'context', params: { contextId: $event } })"
      >
        <template v-slot:item="data">
          <template>
            <v-list-item-content>
              <v-list-item-title v-text="data.item.text"></v-list-item-title>
              <v-list-item-subtitle>{{ data.item.folderName }} </v-list-item-subtitle>
            </v-list-item-content>
          </template>
        </template>
      </v-autocomplete>
    </div>
    <v-list>
      <v-list-item exact :to="{ name: 'dashboard' }">
        <v-list-item-avatar class="mt-0">
          <v-icon small>dashboard</v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>My Stuff</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <!-- <v-list-item exact :to="{ name: 'resources', params: { workspaceId: currentWorkspace.id } }">
        <v-list-item-avatar class="mt-0">
          <v-icon small>receipt </v-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Resources</v-list-item-title>
        </v-list-item-content>
      </v-list-item> -->
    </v-list>
    <v-list dense v-if="sidebarState">
      <v-subheader class="py-0 my-0 pr-0">
        Recent Contexts
        <v-spacer></v-spacer>
      </v-subheader>
      <v-list-item
        v-for="context in recentContexts"
        :key="context.id"
        :to="{ name: 'context', params: { contextId: context.id } }"
      >
        <v-list-item-avatar class="mt-0 mr-2">
          <c-icon icon="context" size="16" color="grey lighten-1"></c-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ context.text }}</v-list-item-title>
          <v-list-item-subtitle>{{ context.folderName }} </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-list dense v-if="sidebarState">
      <v-subheader class="py-0 my-0 pr-0">
        Active Contexts
        <v-spacer></v-spacer>
      </v-subheader>
      <v-list-item
        v-for="context in activeContexts"
        :key="context.id"
        :to="{ name: 'context', params: { contextId: context.id } }"
      >
        <v-list-item-avatar class="mt-0 mr-2">
          <c-icon icon="context" size="16" color="grey lighten-1"></c-icon>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>{{ context.text }}</v-list-item-title>
          <v-list-item-subtitle>{{ context.folderName }} </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <v-btn text><v-icon>add</v-icon> new context</v-btn>
  </v-navigation-drawer>
</template>

<script>
// import useUserSummary from '@/store/useUserSummary';
import { computed } from '@vue/composition-api';

export default {
  setup() {
    const recentContexts = computed(() => {
      // return [];
      // return useUserSummary().filterContexts({
      //   limit: 9,
      //   sortBy: 'lastOpened'
      // }).value;
    });

    const activeContexts = computed(() => {
      return [];
      // return useUserSummary().filterContexts({
      //   limit: 9,
      //   filterFunc: c => c.status == 'active',
      //   sortBy: 'lastOpened'
      // }).value;
    });
    return { recentContexts, activeContexts, allContexts: {} };
  },
  data: () => ({
    settingsModal: false
  }),
  computed: {
     sidebarState() {
      return false;
    }
  },
  methods: {
    // ...mapMutations('components/explorerSidebar', ['toggleSidebar'])
  }
};
</script>

<style></style>
